import { render, staticRenderFns } from "./LinkBtn.vue?vue&type=template&id=17625bb0&scoped=true&"
import script from "./LinkBtn.vue?vue&type=script&lang=js&"
export * from "./LinkBtn.vue?vue&type=script&lang=js&"
import style0 from "./LinkBtn.vue?vue&type=style&index=0&id=17625bb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17625bb0",
  null
  
)

export default component.exports